export default __webpack_public_path__ + "static/media/logo-passenger-hindi.98934428.svg";